import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../../../models/Dashboard/Analytics";
import UnpaidSamplesAnalyticsDashboardAPI from "../../api/dashboards/UnpaidSamplesAnalyticsDashboardAPI";
import { UnpaidSamplesAnalyticsAPIFilters } from "../../../../models/Dashboard/UnpaidSamplesDashboard/UnpaidSamplesAnalyticsDashboardAPIFilters";
import { PaginatedAPIResponse } from "../../../../models/NetworkResponse";

export class UnpaidSamplesAnalyticsDashboardStore {
  analyticsAPI: UnpaidSamplesAnalyticsDashboardAPI;
  basic_tats: LabelValue[];
  unpaid_samples: PaginatedAPIResponse<any>;
  selectedOrderId: string;

  constructor() {
    this.analyticsAPI = new UnpaidSamplesAnalyticsDashboardAPI();
    this.basic_tats = [];
    this.unpaid_samples = {} as PaginatedAPIResponse<any>;
    this.selectedOrderId = "";

    makeObservable(this, {
      basic_tats: observable,
      getTats: action,
      unpaid_samples: observable,
      selectedOrderId: observable,
    });
  }

  getTats = async (filters: UnpaidSamplesAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "tats",
        filters
      )) as LabelValue[];
      this.basic_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getUnpaidSamples = async (filters: UnpaidSamplesAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getUnpaidSamplesData(
        "data/listing",
        filters
      )) as PaginatedAPIResponse<any>;
      this.unpaid_samples = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  setSelectedOrderId = (orderId: string) => {
    this.selectedOrderId = orderId;
  };
}
